import React from 'react';
import Image from 'next/image';
import { resolveUrl } from '@portal-root/geo-utils';
import { useParams } from 'next/navigation';
import { ECountry } from '@portals/help-center-core';
import classnames from 'classnames/bind';
import WBLogo from '@/../public/static/wb-partners.svg';
import { Link } from '@/i18n/navigation';
import { getWindow } from '@/_utils';
import { useLocale } from '@/_hooks/use-locale';
import { useClientEnvContext } from '@/contexts';
import { TRouteCommon } from '@/_constants/routes';
import { getPortalLandingUrl } from './_utils/get-portal-landing-url';
import styles from './index.module.scss';

const cn = classnames.bind(styles);

const BLOCK_NAME = 'Logo';

export const Logo = () => {
  const { country } = useParams<TRouteCommon>();
  const locale = useLocale();
  const { landingUrl } = useClientEnvContext();
  const isChina = country === ECountry.CHINA;

  const currentOrigin = getWindow()?.location.origin;
  // TODO: добавить geoUtils https://youtrack.wildberries.ru/issue/INS-1819
  const href = isChina
    ? resolveUrl(currentOrigin?.replace(/\.ru$/, '.cn'))
    : resolveUrl(currentOrigin);

  const loginHref = getPortalLandingUrl({ href, locale, country, landingUrl });

  return (
    <Link
      className={cn(`${BLOCK_NAME}__link`)}
      href={loginHref}
      prefetch={false}
      target="_blank"
    >
      <Image
        alt=""
        className={cn(`${BLOCK_NAME}__img`)}
        height={24}
        src={WBLogo}
        width={24}
      />
    </Link>
  );
};
